import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import InputControl from '../../components/InputControl/InputControl'
import DropDownControl from '../../components/DropDownControl/DropDownControl'
import { useForm } from 'react-hook-form'
import requestApi from '../../utils/request'
import { useMutation, useQueryClient } from 'react-query'
import useFetchQuery from '../../components/Hooks/useFetchQuery'
import { formatDateToMonthShortwithFormate, getFormData } from '../../functions/common'
import { ReactComponent as SelectImg } from '../../assets/images/selectimg.svg'
import Swal from 'sweetalert2'
import { Outlet, useLocation } from 'react-router-dom'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import { useAdminInfo } from '../../context/AdminContextDetail'
import { useRef } from 'react'
const EditProfile = () => {
    const editProfileSchema = yup.object({
        firstName: yup.string().required('Please enter first name.').trim().max(25,'First name must be most 25 characters.'),
        lastName: yup.string().required('Please enter last name.').trim().max(25,'Last name must be most 25 characters.'),
        email: yup.string().required('Please enter email.'),
        phone: yup
            .string()
            .required('Please enter contact number.')
            .matches(/^[0-9]+$/, {
                message: 'Mobile number must be in digits'
            })
            .min(6, 'Mobile number must be at least 6 digits')
            .max(12, 'Mobile number must be at most 12 digits'),
        // profilePic : yup.mixed().test('required', "Please upload a Profile Photo", (value) => {
        //     return value != null
        //   }).test("type", "Please select .jpeg, .jpg or .png file formate.", function (value) {
        //     return value && (value.type === "image/jpg" || value.type === "image/jpeg" || value.type === "image/png");
        //   })
    })
    const {
        register,
        reset,
        handleSubmit,
        setValue,
        formState: { errors },
        control
    } = useForm({ resolver: yupResolver(editProfileSchema) })
    const [imageErr,setimageErr] = useState('')
    const currentAdminContext = useAdminInfo()
    async function viewAdminProfile() {
        return await requestApi
            .post(`/view-profile`, {}, { headers: true })
            .then((res) => {
                return res.data
            })
    }
    const onSuccess = (response) => {
        const { firstName, lastName, email, phone,profilePic } = response.data
        reset({
            firstName,
            lastName,
            email,
            phone,
            profilePic
        })
        setImageUrl(profilePic) 
        localStorage.setItem(
            'admin',
            JSON.stringify({
                firstName, lastName, email, phone,profilePic
            })
        )
        currentAdminContext.setCurrentUser({
            firstName, lastName, email, phone,profilePic
        })
    }
    const onError = (error) => {}
    const queryClient = useQueryClient()
    function adminEditProfile(payload) {
        return requestApi.post(`/edit-profile`, payload)
    }
    const mutation = useMutation(adminEditProfile, {
        onSuccess: (res) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: res?.data?.meta?.message
            })
            queryClient.invalidateQueries('admin-profile')
            // localStorage.setItem('admin', JSON.stringify({res}))
            // currentAdminContext.setCurrentUser(res)
        },
        onError: (err) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: err?.message
            })
        }
    })
    const { data } = useFetchQuery(
        'admin-profile',
        viewAdminProfile,
        onSuccess,
        onError
    )
    const editOnSubmit = ({profilePic,...data}) => {
        if(imageErr === ''){
        const { firstName, lastName, email, phone } = data
        const payload = {
            // firstName,
            // lastName,
            // email,
            // phone
            profilePic,...data
        }
        const formdata = getFormData(payload)
        mutation.mutate(formdata)
        }
    }
    const uploadImage = useRef(null)
    const [imageUrl, setImageUrl] = useState(null)

    const handleFileUpload = (e) => {  
        if (
            e.target.files[0].type === 'image/jpg' ||
            e.target.files[0].type === 'image/jpeg' ||
            e.target.files[0].type === 'image/png'
        ) {
            setValue('profilePic', e.target.files[0])
            setImageUrl(URL.createObjectURL(e.target.files[0]))   
            setimageErr('')
        } else {
            setimageErr('Please select .jpeg, .jpg or .png file formate.')
        }
    }


    return (
        // <MyAccountLayout>
        <div className="myaccount-sidebar-content">
            <div className="title-text">
                <h3>Edit Profile</h3>
            </div>
            <div className="page-content">
                <Form onSubmit={handleSubmit(editOnSubmit)}>
                    <div className="col-12">
                        <div className="profile-image">
                            <img src={imageUrl}  />
                            <div
                                className="selectimg"
                                onClick={() => uploadImage.current.click()}
                            >
                                <input
                                    type="file"
                                    ref={(event) => {
                                        register('profilePic')
                                        uploadImage.current = event
                                    }}
                                    accept=".jpg,.png,.jpeg"
                                    style={{ display: 'none' }}
                                    onChange={handleFileUpload}
                                />
                                <SelectImg />
                            </div>
                        </div>
                        {/* {errors.profilePic?.message && (
                            <span className="error-message">
                                {errors.profilePic?.message}
                            </span>
                        )} */}
                          {!!imageErr && <span className="error-message">{imageErr}</span>}
                    </div>

                    <div className="form-row">
                        <InputControl
                            label="First Name"
                            name="firstName"
                            register={register}
                            error={errors.firstName?.message}
                        />
                        <InputControl
                            label="Last Name"
                            name="lastName"
                            register={register}
                            error={errors.lastName?.message}
                        />
                    </div>
                    <div className="form-row">
                        <InputControl
                            label="Email Address"
                            name="email"
                            disabled
                            register={register}
                            error={errors.email?.message}
                        />

                        <InputControl
                            label="Contact No."
                            name="phone"
                            register={register}
                            error={errors.phone?.message}
                        />
                    </div>
                    <ButtonWithLoader
                        isLoading={mutation?.isLoading}
                        cssClass="common-btn save-btn"
                    >
                        <Button className="common-btn save-btn" type="submit">
                            Save
                        </Button>
                    </ButtonWithLoader>
                </Form>
            </div>
        </div>
        // </MyAccountLayout>
    )
}

export default EditProfile
